/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */
import type { GradingConfigSnapshotResponse } from './gradingConfigSnapshotResponse';

export type ModuleLecturerResponseGradingConfigSnapshot = GradingConfigSnapshotResponse | null;
